import { useCallback, useState } from 'react';
import { List } from 'immutable';
import FormattedMessage from 'I18n/components/FormattedMessage';
import MultiValueEditor from './MultiValueEditor';
import { syntheticEvent } from 'foundations-components/transitional/utils/SyntheticEvent';
import { EditIcon } from 'foundations-assets';
import { IconButton } from 'foundations-components/transitional/components/IconButton';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const BUTTON_WIDTH_PIXELS = 25;
const MultiValueEditorButton = ({
  disabled = false,
  onChange,
  value
}) => {
  const [showMultiValueEditor, setShowMultiValueEditor] = useState(false);
  const onCancel = useCallback(() => {
    setShowMultiValueEditor(false);
  }, [setShowMultiValueEditor]);
  const onConfirm = useCallback(options => {
    setShowMultiValueEditor(false);
    onChange(syntheticEvent(List.of(...options)));
  }, [onChange]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [showMultiValueEditor && /*#__PURE__*/_jsx(MultiValueEditor, {
      onCancel: onCancel,
      onConfirm: onConfirm,
      value: value
    }), /*#__PURE__*/_jsx("span", {
      style: {
        width: `${BUTTON_WIDTH_PIXELS}px`
      },
      children: /*#__PURE__*/_jsx(IconButton, {
        disabled: disabled,
        onClick: () => {
          setShowMultiValueEditor(true);
        },
        size: "small",
        use: "transparent",
        tooltip: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "customerDataFiltersUI.customerDataFilters.MultiValueEditor.buttonTooltip"
        }),
        marginInline: "0",
        children: /*#__PURE__*/_jsx(EditIcon, {
          size: "200"
        })
      })
    })]
  });
};
export default MultiValueEditorButton;